import React, { PropsWithChildren } from "react";
import styled from "styled-components";
import { theme } from "@ui/styles/theme";
import { alpha, mobile } from "@ui/styles/utils";
import { Clamp } from "@ui/components/containers/clamp";

export const ApplicationFileInformation: React.FC<PropsWithChildren> = (props) => {
	return <Content size={1}>{props.children}</Content>;
};

const Content = styled(Clamp)`
	display: flex;
	justify-content: flex-start;
	background-color: #fff;
	border: 0.5px solid ${alpha("#BEDAFF", 0.5)};
	padding: 5px;
	font-size: 14px;
	border-radius: 7px;
	font-weight: 700;

	color: ${theme.colors.gray};

	@media ${mobile} {
		width: 70%;
	}
`;
